import angular from 'angular';
import { DadosDoDocumentoFormController } from './dados-do-documento.form.controller';

export class DadosDoDocumentoFormComponent implements angular.IComponentOptions {
    static selector = 'dadosDoDocumentoFormComponent';
    static controller = DadosDoDocumentoFormController;
    static template = require('!!html-loader!./dados-do-documento.form.html');
    static transclude = true;
    static bindings = {
        entity: '=',
        form: '<?',
        editable: '<',
    };
}
